import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { getUserAccessHistoryListApi } from '~/features/user-access-history/api/get-user-access-history-list.api';

import type { PaginatedApiResponse } from '~/common/types/api.type';
import type { PaginationMeta } from '~/common/types/pagination.type';
import type {
  UserAccessHistory,
  UserAccessHistoryListParams,
} from '~/features/user-access-history/types/user-access-history.type';

export interface UserAccessHistoryState {
  isLoading: boolean;
  list: UserAccessHistory[];
  meta: PaginationMeta | null;
  params: UserAccessHistoryListParams | null;
}

const initialState: UserAccessHistoryState = {
  isLoading: false,
  list: [],
  meta: null,
  params: null,
};

/**
 * 사용자 접속 이력 목록 조회
 */
export const fetchUserAccessHistoryList = createAsyncThunk<
  PaginatedApiResponse<UserAccessHistory>,
  UserAccessHistoryListParams | undefined
>('userAccessHistory/fetchList', async (params, { rejectWithValue }) => {
  try {
    const { data } = await getUserAccessHistoryListApi(params);
    return data;
  } catch (err) {
    return rejectWithValue(err);
  }
});

const UserAccessHistorySlice = createSlice({
  initialState,
  name: 'userAccessHistory',
  reducers: {
    resetUserAccessHistory: state => {
      state.list = [];
      state.meta = null;
      state.params = null;
      state.isLoading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchUserAccessHistoryList.pending, (state, action) => {
        state.isLoading = true;
        state.params = action.meta.arg ?? null;
      })
      .addCase(fetchUserAccessHistoryList.fulfilled, (state, action) => {
        state.list = Array.isArray(action.payload.data) ? action.payload.data : [];
        state.meta = action.payload.meta ?? null;
        state.isLoading = false;
      })
      .addCase(fetchUserAccessHistoryList.rejected, state => {
        state.isLoading = false;
      });
  },
});

export const { resetUserAccessHistory } = UserAccessHistorySlice.actions;
export default UserAccessHistorySlice;
